'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _businessesFilter = require('./businesses-filter.html');

var _businessesFilter2 = _interopRequireDefault(_businessesFilter);

var _businessesFilter3 = require('./businesses-filter.controller');

var _businessesFilter4 = _interopRequireDefault(_businessesFilter3);

require('./businesses-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var businessesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _businessesFilter2.default,
  controller: _businessesFilter4.default,
  controllerAs: 'vm'
};

exports.default = businessesFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/businesses-filter/businesses-filter.component.js
 **/